import { useEffect, useContext, useState } from "react";
import {
	Input,
	App,
	Space,
	Layout,
	Avatar,
	MenuProps,
	Dropdown,
	Badge,
	notification,
	Typography,
	theme,
	Popover,
	Menu,
} from "antd";
import {
	FileDoneOutlined,
	HomeOutlined,
	InfoCircleOutlined,
	LogoutOutlined,
	NotificationFilled,
	SearchOutlined,
	SettingOutlined,
	UnorderedListOutlined,
	UserOutlined,
	SecurityScanOutlined,
	FileSyncOutlined,
} from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import AppContext, { User } from "../../store/app.context";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { requestGetNotificationList } from "../../services/user.service";
import { formatTime } from "../../utils/TimeFormatter";
import logo from "../../assets/images/islamiva.png";
import { ThemeToggle } from "../ThemeToggle";
import { ItemType } from "antd/es/menu/interface";
import { PiGameControllerDuotone } from "react-icons/pi";

const { Header } = Layout;

type NotificationType = {
	_id: string;
	userId: string;
	type: string;
	title: string;
	body: string;
	createdAt: string;
	updatedAt: string;
	__v: number;
};

const menu: MenuProps["items"] = [
	{
		key: "dashboard",
		icon: <HomeOutlined />,
		label: "Dasbor",
	},
	{
		key: "users",
		icon: <UserOutlined />,
		label: "Pengguna",
	},
	{
		key: "gamification",
		icon: <PiGameControllerDuotone />,
		label: "Gamifikasi",
		children: [
			{
				key: "gamification/badges",
				icon: <FileDoneOutlined />,
				label: "Lencana",
			},
		],
	},
	{
		key: "annotations",
		icon: <FileSyncOutlined />,
		label: "Aturan Tajweed",
	},
	{
		key: "settings",
		icon: <SettingOutlined />,
		label: "Pengaturan",
		children: [
			{
				key: "settings/general",
				icon: <SettingOutlined />,
				label: "Pengaturan Umum",
			},
			{
				key: "settings/app-info",
				icon: <InfoCircleOutlined />,
				label: "Informasi Aplikasi",
			},
			{
				key: "settings/security",
				icon: <SecurityScanOutlined />,
				label: "Keamanan",
			},
		],
	},
	{
		key: "contributor/dashboard",
		icon: <HomeOutlined />,
		label: "Dasbor",
	},
	{
		key: "contributor/annotations",
		icon: <FileSyncOutlined />,
		label: "Aturan Tajweed",
	},
];

const availableMenus = {
	admin: ["dashboard", "users", "gamification", "annotations", "settings"],
	contributor: ["contributor/dashboard", "contributor/annotations"],
};

function CustomHeader({
	onSearch,
	collapsed,
}: {
	onSearch: (value: any) => void;
	collapsed: boolean;
	setCollapsed: (value: boolean) => void;
}) {
	const { message, notification } = App.useApp();
	const context = useContext(AppContext);
	// const user = context.user;
	const navigate = useNavigate();
	const { pathname } = useLocation();
	const page = pathname.replace("/", "");
	const [notifications, setNotifications] = useState<NotificationType[]>([]);
	const [scrolling, setScrolling] = useState(false);

	const logoutHandler = () => {
		axios
			.post(import.meta.env.VITE_API_URL + "/auth/logout")
			.then((response) => {
				if (response.data.code === 200) {
					message.success("Berhasil keluar, sampai jumpa kembali ^_^");

					context.logout();
					navigate("/login");
				} else {
					notification.error({
						message: "Kesalahan!",
						description: response.data.message,
					});
				}
			})
			.catch((error) => {
				notification.error({
					message: "Kesalahan!",
					description: error.message,
				});
			});
	};

	useEffect(() => window.scrollTo(0, 0));

	useEffect(() => {
		const onScroll = () => {
			if (window.scrollY > 0) {
				setScrolling(true);
			} else {
				setScrolling(false);
			}
		};

		window.addEventListener("scroll", onScroll);

		return () => window.removeEventListener("scroll", onScroll);
	}, []);

	const {
		token: { colorPrimaryText, colorBgContainer, colorBorder },
	} = theme.useToken();

	useEffect(() => {
		if (context.isLoggedIn) {
			fetchNotificationList();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [context.isLoggedIn]);

	const fetchNotificationList = () => {
		requestGetNotificationList({
			limit: 10,
			filter: "status:UNREAD",
		})
			.then((response) => {
				setNotifications(response.data.data);
			})
			.catch((error) => {
				notification.error({
					message: "Kesalahan!",
					description: error.message,
				});
			});
	};

	return (
		<Header
			style={{
				height: "auto",
				display: "flex",
				flexDirection: "column",
				position: "sticky",
				top: 0,
				zIndex: 10,
				background: colorBgContainer,
				padding: "0",
				transition: "all 0.3s",
				boxShadow: scrolling ? "0 2px 8px rgba(0, 0, 0, 0.1)" : "none",
			}}>
			{/* Main Header Row */}
			<div
				style={{
					display: "flex",
					alignItems: "center",
					padding: "0 24px",
					width: "100%",
					gap: "24px",
				}}>
				{/* <Button
					type="default"
					icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
					onClick={() => setCollapsed(!collapsed)}
					style={{
						fontSize: "16px",
						marginRight: 16,
					}}
				/> */}
				<div
					style={{
						height: 40,
						// backgroundColor: colorBgContainer,
						// borderRadius: borderRadiusLG,
						alignContent: "center",
						alignItems: "center",
						display: "flex",
						justifyContent: "center",
						cursor: "pointer",
					}}
					onClick={() => navigate(`/dashboard`)}>
					<img
						src={logo}
						alt="logo"
						style={{
							height: "100%",
							objectFit: "contain",
						}}
					/>
					{!collapsed && (
						<div
							style={{
								marginLeft: 8,
								display: "flex",
								flexDirection: "column",
							}}>
							<Typography.Text
								style={{
									margin: 0,
									whiteSpace: "nowrap",
									color: colorPrimaryText,
									fontWeight: "bold",
									fontSize: 16,
									fontFamily: "Geist Mono, monospace",
								}}>
								Islamiva Console
							</Typography.Text>
							<Typography.Text
								style={{
									marginTop: -4,
									fontSize: 8,
									fontWeight: "lighter",
									color: colorPrimaryText,
								}}>
								powered by Codeiva
							</Typography.Text>
						</div>
					)}
				</div>
				{/* Search and Profile Section */}
				<div
					style={{
						width: "100%",
						display: "flex",
						justifyContent: "end",
						alignItems: "center",
						gap: "16px",
					}}>
					{/* <div
						style={{
							display: "flex",
							height: "32px",
							alignItems: "center",
							borderRadius: borderRadius,
							background: colorBgBase,
							border: `1px solid ${colorPrimary}`,
							padding: "0 8px",
							margin: "0 16px",
						}}>
						<Breadcrumb
							separator={<RightOutlined style={{ fontSize: "10px" }} />}
							items={[
								{
									title: <HomeTwoTone />,
									href: `/${teamId}/dashboard`,
								},
								...page
									.split("/")
									.filter((item) => pageNames[item])
									.map((item) => ({
										title: pageNames[item] || item,
									})),
							]}
						/>
					</div> */}
					<Space size="middle" align="center">
						<Input
							onChange={(e) => onSearch(e.target.value)}
							style={{ width: "300px" }}
							placeholder="Cari sesuatu..."
							prefix={<SearchOutlined />}
						/>
						<ThemeToggle />
						<NotificationButton notifications={notifications} />
						<ProfileButton
							user={context.user}
							onLogout={() => {
								logoutHandler();
							}}
						/>
					</Space>
				</div>
			</div>

			{/* Navigation Menu Row */}
			<div
				style={{
					width: "100%",
					borderTop: `1px solid ${colorBorder}`,
					borderBottom: `1px solid ${colorBorder}`,
					background: colorBgContainer,
					padding: "0 24px",
				}}>
				<Menu
					style={{
						background: "transparent",
						border: "none",
						width: "100%",
					}}
					theme="light"
					mode="horizontal"
					// openKeys={[page]}
					selectedKeys={[
						page === "" ? "dashboard" : page,
						...page.split("/").map((item) => item.replace(/-/g, "_")),
					]}
					items={menu?.filter((item: ItemType) => {
						if (context.user.role === "ADMIN") {
							return availableMenus.admin.includes(item?.key as string);
						} else if (context.user.role === "CONTRIBUTOR") {
							return availableMenus.contributor.includes(item?.key as string);
						} else {
							return false;
						}
					})}
					onClick={({ key }) => {
						navigate(`/${key}`);
					}}
				/>
			</div>
		</Header>
	);
}

function NotificationButton({ notifications }: { notifications: NotificationType[] }) {
	const navigate = useNavigate();

	const items: MenuProps["items"] = [
		...(notifications || []).map((notification) => ({
			label: (
				<Popover
					content={
						<div
							style={{
								maxWidth: "300px",
								display: "flex",
								flexDirection: "column",
								alignItems: "end",
								overflow: "hidden",
							}}>
							<Typography.Text
								style={{
									width: "100%",
									textAlign: "start",
								}}>
								{notification.body}
							</Typography.Text>
							<Typography.Text type="secondary">
								{formatTime(notification.createdAt)}
							</Typography.Text>
						</div>
					}
					title={
						<div
							style={{
								width: "300px",
							}}>
							<Typography.Text strong>{notification.title}</Typography.Text>
						</div>
					}
					placement="leftTop">
					<div
						style={{
							width: "100%",
							display: "flex",
							flexDirection: "column",
						}}
						onClick={() => {
							navigate("/notifications");
						}}>
						<Typography.Text strong>{notification.title}</Typography.Text>
						<Typography.Text
							type="secondary"
							style={{
								fontSize: "12px",
								width: "100%",
								whiteSpace: "nowrap",
								overflow: "hidden",
								textOverflow: "ellipsis",
								textAlign: "right",
							}}>
							{formatTime(notification.createdAt)}
						</Typography.Text>
					</div>
				</Popover>
			),
			key: notification._id,
		})),
		{
			type: "divider",
		},
		{
			label: "Lihat Semua",
			key: "view-all",
			icon: <UnorderedListOutlined />,
		},
	];

	return (
		<Dropdown
			menu={{
				items,
				onClick: ({ key }) => {
					if (key === "view-all") {
						navigate("/notifications");
					}
				},
			}}
			trigger={["click"]}
			placement="bottomRight"
			overlayStyle={{
				width: "300px",
			}}>
			<Badge
				count={(notifications || []).length}
				overflowCount={9}
				style={{
					cursor: "pointer",
				}}>
				<Avatar
					shape="square"
					style={{
						cursor: "pointer",
						background: "#01ABE9",
					}}>
					<NotificationFilled />
				</Avatar>
			</Badge>
		</Dropdown>
	);
}

function ProfileButton({ user, onLogout }: { user: User; onLogout: () => void }) {
	const navigate = useNavigate();

	const items: MenuProps["items"] = [
		{
			key: "greeting",
			label: (
				<Space direction="vertical" size={0}>
					<Typography.Text strong>Halo, {user?.name}! 👋</Typography.Text>
					<Typography.Text
						type="secondary"
						style={{
							fontSize: "12px",
						}}>
						{user?.email}
					</Typography.Text>
				</Space>
			),
		},
		{
			type: "divider",
		},
		{
			label: "Profil",
			key: "profile",
			icon: <UserOutlined />,
		},
		{
			label: "Tagihan",
			key: "invoices",
			icon: <FileDoneOutlined />,
		},
		{
			label: "Pengaturan",
			key: "settings",
			icon: <SettingOutlined />,
		},
		{
			type: "divider",
		},
		{
			label: "Logout",
			key: "logout",
			icon: <LogoutOutlined />,
			danger: true,
		},
	];

	return (
		<Dropdown
			menu={{
				items,
				onClick: ({ key }) => {
					if (key === "profile") {
						notification.info({
							message: "Profil",
							description: "Fitur ini belum tersedia",
						});
					} else if (key === "invoices") {
						navigate(`/invoices`);
					} else if (key === "settings") {
						notification.info({
							message: "Pengaturan",
							description: "Fitur ini belum tersedia",
						});
					} else if (key === "logout") {
						onLogout();
					}
				},
			}}
			trigger={["click"]}
			placement="bottomRight"
			overlayStyle={{
				width: "200px",
			}}>
			<Avatar
				shape="square"
				style={{
					cursor: "pointer",
					background: "#01ABE9",
				}}>
				{user?.name?.charAt(0).toUpperCase()}
			</Avatar>
		</Dropdown>
	);
}

export default CustomHeader;
